import type { ParticipantNote } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaAngleDown, FaClone, FaHistory, FaTrash } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { ParticipantNoteCloneModal } from './ParticipantNoteCloneModal';
import { ParticipantNoteDeleteModal } from './ParticipantNoteDeleteModal';
import { ParticipantNoteHistoryModal } from './ParticipantNoteHistoryModal';

interface Props extends ChakraV3.ButtonProps {
  participantNote: ParticipantNote;
  onDelete?: () => void;
}

export const ParticipantNoteActionMenu = (props: Props) => {
  const { participantNote, onDelete, ...rest } = props;

  return (
    <ChakraV3.Menu.Root lazyMount={true} unmountOnExit={false}>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(ParticipantNoteHistoryModal, {
                note: participantNote,
              })
            }
            value='view-history'
          >
            <FaHistory />
            View version history
          </ChakraV3.MenuItem>
          <ChakraV3.MenuItem
            onClick={() => {
              showModal(ParticipantNoteCloneModal, {
                participantId: participantNote.participantId,
                participantNoteId: participantNote.id,
              });
            }}
            value='clone'
          >
            <FaClone />
            Clone
          </ChakraV3.MenuItem>
          <ChakraV3.MenuItem
            onClick={() =>
              showModal(ParticipantNoteDeleteModal, {
                participantId: participantNote.participantId,
                participantNoteId: participantNote.id,
                onDelete,
              })
            }
            value='delete'
            color='danger'
          >
            <FaTrash />
            Delete
          </ChakraV3.MenuItem>
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
      <ChakraV3.Menu.Trigger asChild>
        <ChakraV3.Button {...rest}>
          Actions
          <FaAngleDown />
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
    </ChakraV3.Menu.Root>
  );
};
